module.exports = __webpack_public_path__ + "img/light-mode.af8e745b.svg";